import { initForms } from "./components/common/forms";
import { initGlobal } from "./components/common/global";
import { initSnackbar } from "./components/common/snackbar";
import { initDialog } from "./components/common/dialog";
import { initTabs } from "./components/common/tabs";
import { initNavigation } from "./components/common/navigation";

//ADMIN DATATABLES
import { initDtAdminUserManagement } from "./components/datatables/dtAdminUserManagement";
import { initDtAdminProductManagement } from "./components/datatables/dtAdminProductManagement";
import { initDtAdminFeaturedBenefitManagement } from "./components/datatables/dtAdminFeaturedBenefitManagement";
import { initDtAdminCoreBenefitManagement } from "./components/datatables/dtAdminCoreBenefitManagement";
import { initDtAdminOrderManagement } from "./components/datatables/dtAdminOrderManagement";
import { initDtAdminOrderHistory } from "./components/datatables/dtAdminOrderHistory";
import { initDtAdminBlogManagement } from "./components/datatables/dtAdminBlogManagement";
import { initDtAdminUrlRedirectionManagement } from "./components/datatables/dtAdminUrlRedirectionManagement";
import { initDtAdminDealershipManagement } from "./components/datatables/dtAdminDealershipManagement";
import { initDtAdminVoucherManagement } from "./components/datatables/dtAdminVoucherManagement";
import { initDtAdminCarouselManagement } from "./components/datatables/dtAdminCarouselManagement";

import { initDtAdminManualFinderCategoryManagement } from "./components/datatables/dtAdminManualFinderCategoryManagement";
import { initDtAdminManualFinderProductManagement } from "./components/datatables/dtAdminManualFinderProductManagement";
import { initDtAdminManualFinderEditCategory } from "./components/datatables/dtAdminManualFinderEditCategory";

import { initDtAdminContactUsCategoryManagement } from "./components/datatables/dtAdminContactUsCategoryManagement";
import { initDtAdminContactUsEditCategory } from "./components/datatables/dtAdminContactUsEditCategory";

import { initDtAdminProductBundleCollectionManagement } from "./components/datatables/dtAdminProductBundleCollectionManagement";

//DATATABLES
import { initDtUserOrders } from "./components/datatables/dtUserOrders";

//ADMIN UI
import { initAdminReporting } from "./components/ui/admin/adminReporting";
import { initAdminUserEdit } from "./components/ui/admin/adminUserEdit";
import { initAdminEditSingleProductCore } from "./components/ui/admin/adminProductEditSingleCoreDetails";
import { initAdminEditProductPageContent } from "./components/ui/admin/adminProductEditPageContent";
import { initAdminEditFeaturedBenefit } from "./components/ui/admin/adminFeaturedBenefitEdit";
import { initAdminEditCoreBenefit } from "./components/ui/admin/adminCoreBenefitEdit";
import { initProductDynamicDataManagement } from "./components/ui/admin/adminProductDynamicDataManagement";
import { initAdminOrderWorkflow } from "./components/ui/admin/orderworkflow/adminOrderWorkflow";
import { initAdminBlogManagement } from "./components/ui/admin/adminBlogManagement";
import { adminEditStandardPageContent } from "./components/ui/admin/adminStandardPageManagement";
import { initAdminProductCategoryPicker } from "./components/ui/admin/adminProductCategoryPicker";
import { initAdminProductCollectionPicker } from "./components/ui/admin/adminProductCollectionPicker";

import { initAdminProductBundleCollectionPicker } from "./components/ui/admin/adminProductBundleCollectionManagement";

import { initAdminVoucherEdit } from "./components/ui/admin/adminVoucherEdit";
import { initAdminManualFinderEditProduct } from "./components/ui/admin/adminManualFinderEditProduct";
import { initAdminAboutUsManagement } from "./components/ui/admin/content/adminAboutUsManagement";
import { initAdminCarouselManagement } from "./components/ui/admin/adminCarouselManagement";
import { initAdminProductBulkUpdate } from "./components/ui/admin/adminProductBulkUpdateManagement";

import { initAdminContactUsEditContentItem } from "./components/ui/admin/adminContactUsEditContentItem";

import { initAdminOrderNotes } from "./components/ui/admin/adminOrderNotes";

//UI
import { initHomePage } from "./components/ui/homepage";
import { initFacets } from "./components/ui/facets";
import { initProductPage } from "./components/ui/productPageCore";
import { initBasketEvents } from "./components/ui/basket";
import { initCheckoutView } from "./components/ui/checkout";
import { initLocateDealership } from "./components/ui/dealership";
import { initPaymentSuccess } from "./components/ui/paymentSuccess";
import { initSiteForms } from "./components/ui/siteForms";
import { initMyAccounts } from "./components/ui/myAccount";
import { initManualFinder } from "./components/ui/support/manualFinder";
import { initContactUs } from "./components/ui/support/contactUs";
import { initDiscountConfiguration } from "./components/ui/discountConfiguration";

import { navInit } from "./navx/navInit";

//NAVX
//NOTE: navx is not referenced here as it is initialised in the file:
//Scripts/src/navx/index.js


$(function () {

    //CORE
    initForms();
    initSnackbar();
    initDialog();
    initTabs();
    initNavigation();
    initGlobal();

    //ADMIN UI
    initAdminReporting();
    initAdminUserEdit();
    initAdminEditFeaturedBenefit();
    initAdminEditCoreBenefit();
    initAdminOrderWorkflow();
    initAdminOrderNotes();
    initAdminEditSingleProductCore();
    initAdminEditProductPageContent();
    initAdminBlogManagement();
    adminEditStandardPageContent();
    initAdminProductCategoryPicker();
    initAdminProductCollectionPicker();
    initAdminProductBundleCollectionPicker();
    initAdminVoucherEdit();
    initDtAdminManualFinderCategoryManagement();
    initDtAdminManualFinderProductManagement();
    initDtAdminManualFinderEditCategory();
    initAdminManualFinderEditProduct();
    initAdminContactUsEditContentItem();

    initDtAdminContactUsCategoryManagement();
    initDtAdminContactUsEditCategory();
    initAdminAboutUsManagement();
    initAdminCarouselManagement();
    initAdminProductBulkUpdate();

    initDtAdminProductBundleCollectionManagement();

    //UI
    initHomePage();
    initFacets();
    initProductPage();
    initBasketEvents();
    initCheckoutView();
    initLocateDealership();
    initPaymentSuccess();
    initSiteForms();
    initMyAccounts();
    initManualFinder();
    initContactUs();
    initDiscountConfiguration();

    //ADMIN DT
    initDtAdminUserManagement();
    initDtAdminProductManagement();
    initProductDynamicDataManagement();
    initDtAdminOrderManagement();
    initDtAdminFeaturedBenefitManagement();
    initDtAdminCoreBenefitManagement();
    initDtAdminOrderHistory();
    initDtAdminBlogManagement();
    initDtAdminUrlRedirectionManagement();
    initDtAdminDealershipManagement();
    initDtAdminVoucherManagement();
    initDtAdminCarouselManagement();

    //DT
    initDtUserOrders();

    navInit();
});